import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { baseRoute } from 'config/const';

export default function LandingPage() {
  let navigate = useNavigate();

  useEffect(() => {
    if (
      !window.location.href.includes('liff.state') &&
      window.location.pathname === '/'
    )
      navigate(`${baseRoute}/login`, { replace: true });
  }, [navigate]);

  return <div></div>;
}
